import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

interface Heart {
  id: number
  x: number
  delay: number
  duration: number
  size: number
}

export default function Animation15({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [hearts, setHearts] = useState<Heart[]>([])

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 300)

    const newHearts: Heart[] = []
    for (let i = 0; i < 20; i++) {
      newHearts.push({
        id: i,
        x: 20 + Math.random() * 60,
        delay: Math.random() * 2,
        duration: 3 + Math.random() * 2,
        size: 20 + Math.random() * 30
      })
    }
    setHearts(newHearts)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes floatUp {
          0% {
            transform: translateY(100vh) scale(0) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: 1;
            transform: translateY(80vh) scale(1) rotate(10deg);
          }
          90% {
            opacity: 1;
          }
          100% {
            transform: translateY(-20vh) scale(0.8) rotate(-10deg);
            opacity: 0;
          }
        }
        @keyframes heartBeat {
          0%, 100% { transform: scale(1); }
          25% { transform: scale(1.1); }
          50% { transform: scale(1); }
          75% { transform: scale(1.15); }
        }
        .float-up {
          animation: floatUp var(--duration) ease-out infinite;
          animation-delay: var(--delay);
        }
        .heart-beat {
          animation: heartBeat 1s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative overflow-hidden">
        {/* Cœurs qui flottent */}
        <div className="absolute inset-0 pointer-events-none">
          {hearts.map((heart) => (
            <div
              key={heart.id}
              className="float-up absolute text-tessan-yellow"
              style={{
                left: `${heart.x}%`,
                '--delay': `${heart.delay}s`,
                '--duration': `${heart.duration}s`,
                fontSize: `${heart.size}px`
              } as React.CSSProperties}
            >
              💛
            </div>
          ))}
        </div>

        {/* Badge central */}
        <div className={`relative z-10 transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="heart-beat w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-500 delay-500 ${showBadge ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow heart-beat">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
